import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IDiningDetails } from 'app/shared/model/dining-details.model';
import { getEntities as getDiningDetails } from 'app/entities/dining-details/dining-details.reducer';
import { IMealType } from 'app/shared/model/meal-type.model';
import { getEntity, updateEntity, createEntity, reset } from './meal-type.reducer';

export const MealTypeUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const diningDetails = useAppSelector(state => state.diningDetails.entities);
  const mealTypeEntity = useAppSelector(state => state.mealType.entity);
  const loading = useAppSelector(state => state.mealType.loading);
  const updating = useAppSelector(state => state.mealType.updating);
  const updateSuccess = useAppSelector(state => state.mealType.updateSuccess);

  const handleClose = () => {
    navigate('/meal-type' + location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getDiningDetails({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    values.createdDate = convertDateTimeToServer(values.createdDate);
    values.modifiedDate = convertDateTimeToServer(values.modifiedDate);

    const entity = {
      ...mealTypeEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          createdDate: displayDefaultDateTime(),
          modifiedDate: displayDefaultDateTime(),
        }
      : {
          ...mealTypeEntity,
          createdDate: convertDateTimeFromServer(mealTypeEntity.createdDate),
          modifiedDate: convertDateTimeFromServer(mealTypeEntity.modifiedDate),
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="activitiesApp.mealType.home.createOrEditLabel" data-cy="MealTypeCreateUpdateHeading">
            <Translate contentKey="activitiesApp.mealType.home.createOrEditLabel">Create or edit a MealType</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="meal-type-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('activitiesApp.mealType.active')}
                id="meal-type-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('activitiesApp.mealType.mealTypeCode')}
                id="meal-type-mealTypeCode"
                name="mealTypeCode"
                data-cy="mealTypeCode"
                type="text"
              />
              <ValidatedField
                label={translate('activitiesApp.mealType.mealTypeName')}
                id="meal-type-mealTypeName"
                name="mealTypeName"
                data-cy="mealTypeName"
                type="text"
              />
              <ValidatedField
                label={translate('activitiesApp.mealType.createdDate')}
                id="meal-type-createdDate"
                name="createdDate"
                data-cy="createdDate"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('activitiesApp.mealType.modifiedDate')}
                id="meal-type-modifiedDate"
                name="modifiedDate"
                data-cy="modifiedDate"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/meal-type" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default MealTypeUpdate;
